/**
 * Web Audio chime — no asset needed, no autoplay-blocked <audio> tag.
 * Plays a short 2-tone "ding" (E5 → A5). Cheap, ~180ms.
 * Browsers require a user gesture before the first playback — we lazily
 * initialize AudioContext to comply.
 */
let ctx = null;
const getCtx = () => {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
};

const beep = (frequency, startAt, duration, gain, ac) => {
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = 'sine';
  osc.frequency.value = frequency;
  g.gain.value = 0;
  g.gain.linearRampToValueAtTime(gain, startAt + 0.015);
  g.gain.linearRampToValueAtTime(0, startAt + duration);
  osc.connect(g).connect(ac.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.02);
};

export const playChatChime = () => {
  const ac = getCtx();
  if (!ac) return;
  // Some browsers suspend the context until a gesture; resume() is a no-op otherwise.
  if (ac.state === 'suspended') ac.resume().catch(() => {});
  const now = ac.currentTime;
  beep(659.25, now,        0.13, 0.18, ac); // E5
  beep(880.00, now + 0.11, 0.16, 0.22, ac); // A5
};
